// extracted by mini-css-extract-plugin
module.exports = {"root":"lightedMirrorsPage_root__3-cT3"};